import { ChakraProvider } from "@chakra-ui/react";
import { css, Global, ThemeProvider } from "@emotion/react";
import "focus-visible/dist/focus-visible";
import { Settings } from "luxon";
import { PropsWithChildren, ReactElement, StrictMode } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import theme from "./theme";
import VueContext, { VueContextType } from "./vueContext";

const GlobalStyles = css`
  /*
    This will hide the focus indicator if the element receives focus    via the mouse,
    but it will still show up on keyboard focus.
  */
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
    box-shadow: none;
  }
  html {
    -webkit-font-smoothing: auto;
  }
  body {
    line-height: initial;
  }
`;

export default function ReactAppContainer({
  vueProps,
  children,
}: PropsWithChildren<{
  vueProps: VueContextType;
}>): ReactElement {
  if (vueProps?.$store.state.user?.languageCode) {
    Settings.defaultLocale = vueProps.$store?.state?.user?.languageCode;
  }
  return (
    <StrictMode>
      <Router>
        <ChakraProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <Global styles={GlobalStyles} />
            <VueContext.Provider value={vueProps}>{children}</VueContext.Provider>
          </ThemeProvider>
        </ChakraProvider>
      </Router>
    </StrictMode>
  );
}
